import { Controller } from "@hotwired/stimulus"

// Manages the wizard form interactions:
// - Quick period preset buttons (2/4/6 weeks)
// - Team selection change handling (shows the externals table of the selected teams)
export default class extends Controller {
  static targets = ["startDate", "endDate", "externalCard", "externalTeam", "availabilityFrame"]

  setPresetPeriod(event) {
    const weeks = parseInt(event.currentTarget.dataset.weeks, 10)
    if (!weeks) return

    const today = new Date()
    // Start from next Monday
    const dayOfWeek = today.getDay()
    const daysUntilMonday = dayOfWeek === 0 ? 1 : (8 - dayOfWeek)
    const start = new Date(today)
    start.setDate(today.getDate() + daysUntilMonday)

    const end = new Date(start)
    end.setDate(start.getDate() + (weeks * 7) - 1)

    if (this.hasStartDateTarget) {
      this.startDateTarget.value = this.formatDate(start)
    }
    if (this.hasEndDateTarget) {
      this.endDateTarget.value = this.formatDate(end)
    }
    this.refreshAvailability()
  }

  selectMonth(event) {
    const year = parseInt(event.currentTarget.dataset.year, 10)
    const month = parseInt(event.currentTarget.dataset.month, 10) // 1-based
    const start = new Date(year, month - 1, 1)
    const end = new Date(year, month, 0) // last day of month

    if (this.hasStartDateTarget) {
      this.startDateTarget.value = this.formatDate(start)
    }
    if (this.hasEndDateTarget) {
      this.endDateTarget.value = this.formatDate(end)
    }
    this.refreshAvailability()
  }

  selectQuarter(event) {
    const year = parseInt(event.currentTarget.dataset.year, 10)
    const quarter = parseInt(event.currentTarget.dataset.quarter, 10)
    const startMonth = (quarter - 1) * 3
    const start = new Date(year, startMonth, 1)
    const end = new Date(year, startMonth + 3, 0)

    if (this.hasStartDateTarget) {
      this.startDateTarget.value = this.formatDate(start)
    }
    if (this.hasEndDateTarget) {
      this.endDateTarget.value = this.formatDate(end)
    }
    this.refreshAvailability()
  }

  refreshAvailability() {
    if (!this.hasStartDateTarget || !this.hasEndDateTarget) return

    this.availabilityFrameTargets.forEach((frame) => {
      this.keepTicks(frame)
      const url = new URL(frame.dataset.url, window.location.origin)
      url.searchParams.set("start_date", this.startDateTarget.value)
      url.searchParams.set("end_date", this.endDateTarget.value)
      frame.src = url.toString()
    })
  }

  // Een nieuwe periode laadt het frame opnieuw; niet-opgeslagen vinkjes op dagen die in beide periodes zitten blijven staan.
  keepTicks(frame) {
    const ticks = new Map(
      Array.from(frame.querySelectorAll("input[type='checkbox'][id^='external_availability_']")).map((box) => [box.id, box.checked])
    )
    frame.addEventListener("turbo:frame-load", () => {
      ticks.forEach((checked, id) => {
        const box = frame.querySelector(`#${CSS.escape(id)}`)
        if (box) box.checked = checked
      })
    }, { once: true })
  }

  teamChanged() {
    if (!this.hasExternalCardTarget) return

    const selected = new Set(
      Array.from(this.element.querySelectorAll("input[name='team_ids[]']:checked")).map((input) => input.value)
    )
    let anyVisible = false
    this.externalTeamTargets.forEach((fieldset) => {
      const visible = fieldset.dataset.teamIds.split(" ").some((id) => selected.has(id))
      fieldset.hidden = !visible
      fieldset.disabled = !visible
      anyVisible = anyVisible || visible
    })
    this.externalCardTarget.hidden = !anyVisible
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }
}
